// extracted by mini-css-extract-plugin
export default {"PrimaryTitleWrapper":"Auditor_PrimaryTitleWrapper__dQHpt","MainWrapper":"Auditor_MainWrapper__hfsNW","ListWrapper":"Auditor_ListWrapper__L72m6"};